// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pills_wrapper__TyBzl","list":"Pills_list__PGyf4","pill":"Pills_pill__asvfc"};